import { IUser } from './iuser';
import { Role } from '../roles/role';

export class User implements IUser {
    Id: string;
    UserName: string;
    FirstName: string;
    LastName: string;
    DocumentNumber: string;
    Birthdate: Date;
    Photo: string;
    Language: string;
    IsActive: boolean;
    Email: string;
    EmailConfirmed: boolean;
    PhoneNumber: string;
    PhoneNumberConfirmed: boolean;
    RegisterDate: Date;
    RegisterBy: string;
    UpdatedDate: Date;
    UpdatedBy: string;
    IdentificationTypeId: number;
    Roles: Role[];

    Password: string;
    ConfirmPassword: string;

    constructor() {
        this.Id = '';
        this.UserName = '';
        this.FirstName = '';
        this.LastName = '';
        this.DocumentNumber = '';
        this.Birthdate = null;
        this.Photo = '';
        this.Language = '';
        this.IsActive = true;
        this.Email = '';
        this.EmailConfirmed = false;
        this.PhoneNumber = '';
        this.PhoneNumberConfirmed = false;
        this.RegisterDate = null;
        this.RegisterBy = '';
        this.UpdatedDate = null;
        this.UpdatedBy = '';
        this.IdentificationTypeId = -1;
        this.Roles = [];

        this.Password = '';
        this.ConfirmPassword = '';
    }
}


// WEBPACK FOOTER //
// ./src/app/main/models/users/user.ts